module.exports = __webpack_public_path__ + "static/media/member3.ed5d998f.jpg";